import {
    prepareTopNavInternalVariables,
    TopNavInternalVariablesProps,
} from './top-nav-v3-theme-utils';

export const setTopNavInternalVariables = (customColor: string) => {
    const computedStyle = getComputedStyle(document.documentElement);

    // Top nav base color configured in the TSE.
    const navBackground = computedStyle
        .getPropertyValue('--ts-var-nav-background')
        .trim();

    const theme: TopNavInternalVariablesProps = prepareTopNavInternalVariables(
        navBackground || customColor,
    );

    const style = document.getElementById('root')?.style;
    if (!style) return;

    style.setProperty('--top-nav-background', theme.topNavBackground);
    style.setProperty('--top-nav-color', theme.topNavColor);
    style.setProperty(
        '--top-nav-action-item-background',
        theme.topNavActionItemBackground,
    );
    style.setProperty(
        '--top-nav-action-item-placeholder-color',
        theme.topNavPlaceholderColor,
    );
    style.setProperty(
        '--top-nav-action-item-border-color',
        theme.topNavBorderColor,
    );
    style.setProperty(
        '--top-nav-action-item-border-secondary-color',
        theme.topNavBorderFocusColor,
    );
    style.setProperty('--top-nav-ts-logo-filter', theme.topNavTsLogoFilter);
    style.setProperty('--top-nav-active-color', theme.topNavColor);
    style.setProperty(
        '--top-nav-action-item-active-background',
        theme.topNavBorderFocusColor,
    );
};
